/**
 * 显式列出所有配色 i18n key，供 i18next-parser 提取；
 * 与 useProductColor.translateColorLabel 中 `${prefix}.${key}` 的取值一致。
 */
export type ColorLabelTranslate = (key: string) => string;

export function translatePrefixedColorKey(
  fullKey: string,
  shortKey: string,
  t: ColorLabelTranslate
): string {
  switch (fullKey) {
    // 鼠标配色
    case "mouse.colors.z7Black":
      return t("mouse.colors.z7Black");
    case "mouse.colors.z7Red":
      return t("mouse.colors.z7Red");
    case "mouse.colors.z7Silvery":
      return t("mouse.colors.z7Silvery");
    case "mouse.colors.z7Purple":
      return t("mouse.colors.z7Purple");
    case "mouse.colors.z7MasterPinegreen":
      return t("mouse.colors.z7MasterPinegreen");
    case "mouse.colors.z7MasterBlack":
      return t("mouse.colors.z7MasterBlack");
    case "mouse.colors.z7MasterSilver":
      return t("mouse.colors.z7MasterSilver");
    case "mouse.colors.z7MasterRed":
      return t("mouse.colors.z7MasterRed");
    case "mouse.colors.s9ultrav2White":
      return t("mouse.colors.s9ultrav2White");
    case "mouse.colors.s9ultrav2Red":
      return t("mouse.colors.s9ultrav2Red");
    case "mouse.colors.s9ultrav2Lightpurple":
      return t("mouse.colors.s9ultrav2Lightpurple");
    case "mouse.colors.s9ultrav2Silver":
      return t("mouse.colors.s9ultrav2Silver");
    case "mouse.colors.s9ultrav2Luotianyi":
      return t("mouse.colors.s9ultrav2Luotianyi");
    case "mouse.colors.s9prov2Black":
      return t("mouse.colors.s9prov2Black");
    case "mouse.colors.s9prov2White":
      return t("mouse.colors.s9prov2White");
    case "mouse.colors.s9prov2Luotianyi":
      return t("mouse.colors.s9prov2Luotianyi");
    case "mouse.colors.s9White":
      return t("mouse.colors.s9White");
    case "mouse.colors.s9Black":
      return t("mouse.colors.s9Black");
    case "mouse.colors.s9seWhite":
      return t("mouse.colors.s9seWhite");
    case "mouse.colors.s9seBlack":
      return t("mouse.colors.s9seBlack");
    case "mouse.colors.s9proBlack":
      return t("mouse.colors.s9proBlack");
    case "mouse.colors.s9proWhite":
      return t("mouse.colors.s9proWhite");
    case "mouse.colors.s9proRed":
      return t("mouse.colors.s9proRed");
    case "mouse.colors.s9proSilver":
      return t("mouse.colors.s9proSilver");
    case "mouse.colors.s9proBlackpurple":
      return t("mouse.colors.s9proBlackpurple");
    case "mouse.colors.s9maxCyan":
      return t("mouse.colors.s9maxCyan");
    case "mouse.colors.s9ultraWhite":
      return t("mouse.colors.s9ultraWhite");
    case "mouse.colors.s9ultraRed":
      return t("mouse.colors.s9ultraRed");
    case "mouse.colors.s9ultraBlack":
      return t("mouse.colors.s9ultraBlack");
    case "mouse.colors.s9ultraBlackpurple":
      return t("mouse.colors.s9ultraBlackpurple");
    case "mouse.colors.s9ultraSilver":
      return t("mouse.colors.s9ultraSilver");
    case "mouse.colors.x23ZhuoyueWhite":
      return t("mouse.colors.x23ZhuoyueWhite");
    case "mouse.colors.x23ZhuoyueBerryRed":
      return t("mouse.colors.x23ZhuoyueBerryRed");
    case "mouse.colors.x23ZhuoyueLightBlue":
      return t("mouse.colors.x23ZhuoyueLightBlue");
    case "mouse.colors.x23BerryRed":
      return t("mouse.colors.x23BerryRed");
    case "mouse.colors.x23MaxWhite":
      return t("mouse.colors.x23MaxWhite");
    case "mouse.colors.x23MaxBerryRed":
      return t("mouse.colors.x23MaxBerryRed");
    case "mouse.colors.x23SEWhite":
      return t("mouse.colors.x23SEWhite");
    case "mouse.colors.x23SELightGreen":
      return t("mouse.colors.x23SELightGreen");
    case "mouse.colors.x23SEPink":
      return t("mouse.colors.x23SEPink");
    case "mouse.colors.x23SEBlack":
      return t("mouse.colors.x23SEBlack");
    case "mouse.colors.x23SEBerryRed":
      return t("mouse.colors.x23SEBerryRed");
    case "mouse.colors.x23ProWhite":
      return t("mouse.colors.x23ProWhite");
    case "mouse.colors.x23ProBlack":
      return t("mouse.colors.x23ProBlack");
    case "mouse.colors.x23ProBlue":
      return t("mouse.colors.x23ProBlue");
    case "mouse.colors.x23ProJiangGuoHong":
      return t("mouse.colors.x23ProJiangGuoHong");
    case "mouse.colors.x23ProShuMeiPink":
      return t("mouse.colors.x23ProShuMeiPink");
    case "mouse.colors.x23ProCyberPanda":
      return t("mouse.colors.x23ProCyberPanda");
    case "mouse.colors.s7proWhite":
      return t("mouse.colors.s7proWhite");
    case "mouse.colors.s7White":
      return t("mouse.colors.s7White");
    case "mouse.colors.s7BerryRed":
      return t("mouse.colors.s7BerryRed");
    case "mouse.colors.s7Green":
      return t("mouse.colors.s7Green");
    case "mouse.colors.s7plusWhite":
      return t("mouse.colors.s7plusWhite");
    case "mouse.colors.s7plusBlack":
      return t("mouse.colors.s7plusBlack");
    case "mouse.colors.s7seWhite":
      return t("mouse.colors.s7seWhite");
    case "mouse.colors.s7seBerryRed":
      return t("mouse.colors.s7seBerryRed");
    case "mouse.colors.s7seGreen":
      return t("mouse.colors.s7seGreen");
    case "mouse.colors.s7maxWhite":
      return t("mouse.colors.s7maxWhite");
    case "mouse.colors.s7maxBlackGold":
      return t("mouse.colors.s7maxBlackGold");
    case "mouse.colors.s7maxJiangGuoHong":
      return t("mouse.colors.s7maxJiangGuoHong");
    case "mouse.colors.s7ultraWhite":
      return t("mouse.colors.s7ultraWhite");
    case "mouse.colors.s7ultraBlackGold":
      return t("mouse.colors.s7ultraBlackGold");
    case "mouse.colors.s7ultraJiangGuoHong":
      return t("mouse.colors.s7ultraJiangGuoHong");
    case "mouse.colors.s2White":
      return t("mouse.colors.s2White");
    case "mouse.colors.s2Black":
      return t("mouse.colors.s2Black");
    case "mouse.colors.s2Blue":
      return t("mouse.colors.s2Blue");
    case "mouse.colors.s2BerryRed":
      return t("mouse.colors.s2BerryRed");
    case "mouse.colors.s2Green":
      return t("mouse.colors.s2Green");
    case "mouse.colors.s9v2MasterMambagreen":
      return t("mouse.colors.s9v2MasterMambagreen");
    case "mouse.colors.s9v2MasterPlusBlack":
      return t("mouse.colors.s9v2MasterPlusBlack");
    case "mouse.colors.s9v2MasterPlusPurple":
      return t("mouse.colors.s9v2MasterPlusPurple");
    case "mouse.colors.s9v2MasterPlusSilver":
      return t("mouse.colors.s9v2MasterPlusSilver");
    case "mouse.colors.s9v2MasterPlusRed":
      return t("mouse.colors.s9v2MasterPlusRed");
    case "mouse.colors.s9v2UltimateLightblue":
      return t("mouse.colors.s9v2UltimateLightblue");
    case "mouse.colors.s9v2UltimateRed":
      return t("mouse.colors.s9v2UltimateRed");
    case "mouse.colors.s9v2UltimateSilver":
      return t("mouse.colors.s9v2UltimateSilver");
    case "mouse.colors.x23CarbonBlack":
      return t("mouse.colors.x23CarbonBlack");
    case "mouse.colors.x23CarbonQianlan":
      return t("mouse.colors.x23CarbonQianlan");
    case "mouse.colors.x23CarbonSilver":
      return t("mouse.colors.x23CarbonSilver");
    case "mouse.colors.x23LCarbonBlack":
      return t("mouse.colors.x23LCarbonBlack");
    case "mouse.colors.x23LCarbonSilver":
      return t("mouse.colors.x23LCarbonSilver");
    case "mouse.colors.a6XiangYaWhite":
      return t("mouse.colors.a6XiangYaWhite");
    case "mouse.colors.a6ProXiangYaWhite":
      return t("mouse.colors.a6ProXiangYaWhite");
    case "mouse.colors.a6ProBingChuanBlue":
      return t("mouse.colors.a6ProBingChuanBlue");
    case "mouse.colors.a6ProJingdianBlack":
      return t("mouse.colors.a6ProJingdianBlack");
    case "mouse.colors.a6ProYingHuaPink":
      return t("mouse.colors.a6ProYingHuaPink");
    case "mouse.colors.a6MaxXiangYaWhite":
      return t("mouse.colors.a6MaxXiangYaWhite");
    case "mouse.colors.a7SEWhite":
      return t("mouse.colors.a7SEWhite");
    case "mouse.colors.a7White":
      return t("mouse.colors.a7White");
    case "mouse.colors.a7Black":
      return t("mouse.colors.a7Black");
    case "mouse.colors.a7ProWhite":
      return t("mouse.colors.a7ProWhite");
    case "mouse.colors.a7ProBlack":
      return t("mouse.colors.a7ProBlack");
    case "mouse.colors.alpha7White":
      return t("mouse.colors.alpha7White");
    case "mouse.colors.alpha7Black":
      return t("mouse.colors.alpha7Black");
    case "mouse.colors.alpha7Pink":
      return t("mouse.colors.alpha7Pink");
    case "mouse.colors.alpha6Blackwhite":
      return t("mouse.colors.alpha6Blackwhite");
    case "mouse.colors.alpha6Blackorange":
      return t("mouse.colors.alpha6Blackorange");
    case "mouse.colors.alpha6Berryred":
      return t("mouse.colors.alpha6Berryred");
    case "mouse.colors.z7MaxWhite":
      return t("mouse.colors.z7MaxWhite");
    case "mouse.colors.z7MaxBlack":
      return t("mouse.colors.z7MaxBlack");
    case "mouse.colors.gs02ProJiYeBlack":
      return t("mouse.colors.gs02ProJiYeBlack");
    case "mouse.colors.gs02ProYueGuangBai":
      return t("mouse.colors.gs02ProYueGuangBai");
    case "mouse.colors.e7V2Black":
      return t("mouse.colors.e7V2Black");
    case "mouse.colors.e7V2White":
      return t("mouse.colors.e7V2White");
    case "mouse.colors.e7V3Black":
      return t("mouse.colors.e7V3Black");
    case "mouse.colors.e7V3White":
      return t("mouse.colors.e7V3White");
    case "mouse.colors.e7V3BerryRed":
      return t("mouse.colors.e7V3BerryRed");
    // 后台产品图标签 / 配色键兼容（含历史拼写 berryrod）
    case "mouse.colors.e7v3berryred":
      return t("mouse.colors.e7V3BerryRed");
    case "mouse.colors.e7v3berryrod":
      return t("mouse.colors.e7V3BerryRed");
    case "mouse.colors.berryrod":
      return t("mouse.colors.e7V3BerryRed");
    case "mouse.colors.e7V2MaxWhite":
      return t("mouse.colors.e7V2MaxWhite");
    case "mouse.colors.e7V2MaxBlack":
      return t("mouse.colors.e7V2MaxBlack");
    case "mouse.colors.e7V2MaxBerryRed":
      return t("mouse.colors.e7V2MaxBerryRed");
    case "mouse.colors.e7White":
      return t("mouse.colors.e7White");
    case "mouse.colors.e7Black":
      return t("mouse.colors.e7Black");
    case "mouse.colors.e7BerryRed":
      return t("mouse.colors.e7BerryRed");
    case "mouse.colors.e7LemonGreen":
      return t("mouse.colors.e7LemonGreen");
    case "mouse.colors.e7SkyBlue":
      return t("mouse.colors.e7SkyBlue");
    case "mouse.colors.e7FireRed":
      return t("mouse.colors.e7FireRed");
    case "mouse.colors.e7Foggywhite":
      return t("mouse.colors.e7Foggywhite");
    case "mouse.colors.e7ProBlack":
      return t("mouse.colors.e7ProBlack");
    case "mouse.colors.e7ProWhite":
      return t("mouse.colors.e7ProWhite");
    case "mouse.colors.e7ProBerryRed":
      return t("mouse.colors.e7ProBerryRed");
    case "mouse.colors.e9White":
      return t("mouse.colors.e9White");
    case "mouse.colors.e9Black":
      return t("mouse.colors.e9Black");
    case "mouse.colors.e9BerryRed":
      return t("mouse.colors.e9BerryRed");
    case "mouse.colors.e9LemonGreen":
      return t("mouse.colors.e9LemonGreen");
    case "mouse.colors.e11White":
      return t("mouse.colors.e11White");
    case "mouse.colors.e11BerryRed":
      return t("mouse.colors.e11BerryRed");
    case "mouse.colors.e11SakuraPink":
      return t("mouse.colors.e11SakuraPink");
    case "mouse.colors.a8WBUltraPanda":
      return t("mouse.colors.a8WBUltraPanda");
    case "mouse.colors.a8WBUltraBerryRed":
      return t("mouse.colors.a8WBUltraBerryRed");
    case "mouse.colors.g2seaWhite":
      return t("mouse.colors.g2seaWhite");
    case "mouse.colors.g2seaBlack":
      return t("mouse.colors.g2seaBlack");
    case "mouse.colors.g5XiangBinBlue":
      return t("mouse.colors.g5XiangBinBlue");
    case "mouse.colors.g5JinShuBlack":
      return t("mouse.colors.g5JinShuBlack");
    case "mouse.colors.g5KaiJiaRed":
      return t("mouse.colors.g5KaiJiaRed");
    case "mouse.colors.e11V2White":
      return t("mouse.colors.e11V2White");
    case "mouse.colors.e11V2BerryRed":
      return t("mouse.colors.e11V2BerryRed");
    // 键盘配色 - X87
    case "keyboard.colors.x87White":
      return t("keyboard.colors.x87White");
    case "keyboard.colors.x87Baifenjianbian":
      return t("keyboard.colors.x87Baifenjianbian");
    case "keyboard.colors.x87Duantan":
      return t("keyboard.colors.x87Duantan");
    case "keyboard.colors.x87Fushihui":
      return t("keyboard.colors.x87Fushihui");
    case "keyboard.colors.x87Jingmihaiyang":
      return t("keyboard.colors.x87Jingmihaiyang");
    case "keyboard.colors.x87Piwen":
      return t("keyboard.colors.x87Piwen");
    case "keyboard.colors.x87Piwenbai":
      return t("keyboard.colors.x87Piwenbai");
    case "keyboard.colors.x87Qingti":
      return t("keyboard.colors.x87Qingti");
    case "keyboard.colors.x87Tianxinfen":
      return t("keyboard.colors.x87Tianxinfen");
    case "keyboard.colors.x87Weichen":
      return t("keyboard.colors.x87Weichen");
    case "keyboard.colors.x87Wutou":
      return t("keyboard.colors.x87Wutou");
    case "keyboard.colors.x87Xueshanjianbian":
      return t("keyboard.colors.x87Xueshanjianbian");
    case "keyboard.colors.x87Blackpink":
      return t("keyboard.colors.x87Blackpink");
    case "keyboard.colors.x87Zheying":
      return t("keyboard.colors.x87Zheying");
    case "keyboard.colors.x87FlameRed":
      return t("keyboard.colors.x87FlameRed");

    // 键盘配色 - X87HE
    case "keyboard.colors.x87heBlackpink":
      return t("keyboard.colors.x87heBlackpink");
    case "keyboard.colors.x87heBlue":
      return t("keyboard.colors.x87heBlue");
    case "keyboard.colors.x87heDuantan":
      return t("keyboard.colors.x87heDuantan");
    case "keyboard.colors.x87heWhite":
      return t("keyboard.colors.x87heWhite");

    // 键盘配色 - Alpha 87
    case "keyboard.colors.alpha87Silver":
      return t("keyboard.colors.alpha87Silver");

    // 键盘配色 - X98
    case "keyboard.colors.x98Purple":
      return t("keyboard.colors.x98Purple");
    case "keyboard.colors.x98Taofen":
      return t("keyboard.colors.x98Taofen");
    case "keyboard.colors.x98Yunjianlan":
      return t("keyboard.colors.x98Yunjianlan");
    case "keyboard.colors.x98Zheyingzhiguang":
      return t("keyboard.colors.x98Zheyingzhiguang");

    // 键盘配色 - SMART875
    case "keyboard.colors.smart875Black":
      return t("keyboard.colors.smart875Black");
    case "keyboard.colors.smart875Red":
      return t("keyboard.colors.smart875Red");
    case "keyboard.colors.smart875Silvery":
      return t("keyboard.colors.smart875Silvery");

    // 键盘配色 - DK68
    case "keyboard.colors.dk68Black":
      return t("keyboard.colors.dk68Black");
    case "keyboard.colors.dk68White":
      return t("keyboard.colors.dk68White");
    case "keyboard.colors.dk68Berryred":
      return t("keyboard.colors.dk68Berryred");
    case "keyboard.colors.zap68Black":
      return t("keyboard.colors.zap68Black");
    case "keyboard.colors.zap68BlackPink":
      return t("keyboard.colors.zap68BlackPink");
    case "keyboard.colors.zap68FoggyBlack":
      return t("keyboard.colors.zap68FoggyBlack");

    // 键盘配色 - DEEP68
    case "keyboard.colors.deep68White":
      return t("keyboard.colors.deep68White");
    case "keyboard.colors.deep68Pink":
      return t("keyboard.colors.deep68Pink");

    // 键盘配色 - battle68
    case "keyboard.colors.battle68Black":
      return t("keyboard.colors.battle68Black");
    case "keyboard.colors.battle68Blackred":
      return t("keyboard.colors.battle68Blackred");
    case "keyboard.colors.battle68Blackyellow":
      return t("keyboard.colors.battle68Blackyellow");
    case "keyboard.colors.battle68Weichen":
      return t("keyboard.colors.battle68Weichen");

    // 键盘配色 - Tank68 HE
    case "keyboard.colors.tank68Black":
      return t("keyboard.colors.tank68Black");
    case "keyboard.colors.tank68Blackredcontourline":
      return t("keyboard.colors.tank68Blackredcontourline");
    case "keyboard.colors.tank68Blackcontourline":
      return t("keyboard.colors.tank68Blackcontourline");
    case "keyboard.colors.tank68Whitecontourline":
      return t("keyboard.colors.tank68Whitecontourline");

    // 键盘配色 - DEEP80 MAX / DEEP80 Pro
    case "keyboard.colors.deep80maxWhite":
      return t("keyboard.colors.deep80maxWhite");
    case "keyboard.colors.deep80maxBerryRed":
      return t("keyboard.colors.deep80maxBerryRed");
    case "keyboard.colors.deep80maxBerryRedTranslucent":
      return t("keyboard.colors.deep80maxBerryRedTranslucent");
    case "keyboard.colors.deep80proWhite":
      return t("keyboard.colors.deep80proWhite");
    case "keyboard.colors.deep80proBerryRed":
      return t("keyboard.colors.deep80proBerryRed");
    case "keyboard.colors.deep80proBerryRedTranslucent":
      return t("keyboard.colors.deep80proBerryRedTranslucent");

    // 键盘配色 - DK68 Star
    case "keyboard.colors.dk68StarBlack":
      return t("keyboard.colors.dk68StarBlack");
    case "keyboard.colors.dk68StarWhite":
      return t("keyboard.colors.dk68StarWhite");
    case "keyboard.colors.dk68StarBerryred":
      return t("keyboard.colors.dk68StarBerryred");
    case "keyboard.colors.dk68StarZheying":
      return t("keyboard.colors.dk68StarZheying");

    // 键盘配色 - DK68 V2
    case "keyboard.colors.dk68v2Foggyblack":
      return t("keyboard.colors.dk68v2Foggyblack");
    case "keyboard.colors.dk68v2Foggywhite":
      return t("keyboard.colors.dk68v2Foggywhite");
    case "keyboard.colors.dk68v2Foggypink":
      return t("keyboard.colors.dk68v2Foggypink");
    case "keyboard.colors.dk68v2White":
      return t("keyboard.colors.dk68v2White");

    // 键盘配色 - DK68 Pro
    case "keyboard.colors.dk68proBlack":
      return t("keyboard.colors.dk68proBlack");
    case "keyboard.colors.dk68proWhite":
      return t("keyboard.colors.dk68proWhite");
    case "keyboard.colors.dk68proBerryred":
      return t("keyboard.colors.dk68proBerryred");

    // 键盘配色 - DK68-Pro
    case "keyboard.colors.eweadndk68proBlack":
      return t("keyboard.colors.eweadndk68proBlack");
    case "keyboard.colors.eweadndk68proWhite":
      return t("keyboard.colors.eweadndk68proWhite");
    case "keyboard.colors.eweadndk68proBerryred":
      return t("keyboard.colors.eweadndk68proBerryred");

    // 键盘配色 - DK80
    case "keyboard.colors.dk80White":
      return t("keyboard.colors.dk80White");
    case "keyboard.colors.dk80Whitepink":
      return t("keyboard.colors.dk80Whitepink");
    case "keyboard.colors.dk80Zheying":
      return t("keyboard.colors.dk80Zheying");
    case "keyboard.colors.dk80Denggaoxianwhite":
      return t("keyboard.colors.dk80Denggaoxianwhite");
    case "keyboard.colors.dk80Russiawhite":
      return t("keyboard.colors.dk80Russiawhite");
    case "keyboard.colors.dk80Weichen":
      return t("keyboard.colors.dk80Weichen");
    case "keyboard.colors.dk80Russiaweichen":
      return t("keyboard.colors.dk80Russiaweichen");

    // 键盘配色 - DK63
    case "keyboard.colors.dk63Black":
      return t("keyboard.colors.dk63Black");
    case "keyboard.colors.dk63White":
      return t("keyboard.colors.dk63White");
    case "keyboard.colors.dk63Berryred":
      return t("keyboard.colors.dk63Berryred");
    // 键盘配色 - DK63Star V2（本地 label + 后台配色 label）
    case "keyboard.colors.dk63StarV2White":
      return t("keyboard.colors.dk63StarV2White");
    case "keyboard.colors.dk63StarV2Black":
      return t("keyboard.colors.dk63StarV2Black");
    case "keyboard.colors.DK63StarV2White":
      return t("keyboard.colors.DK63StarV2White");
    case "keyboard.colors.DK63StarV2Black":
      return t("keyboard.colors.DK63StarV2Black");
    case "keyboard.colors.dk63v2WhiteSidePrinted":
      return t("keyboard.colors.dk63v2WhiteSidePrinted");
    case "keyboard.colors.dk63v2WhiteMistSheer":
      return t("keyboard.colors.dk63v2WhiteMistSheer");
    case "keyboard.colors.dk63v2WhiteCarbonPattern":
      return t("keyboard.colors.dk63v2WhiteCarbonPattern");
    case "keyboard.colors.dk63v2ContourLine":
      return t("keyboard.colors.dk63v2ContourLine");
    case "keyboard.colors.dk63v2PinkSidePrinted":
      return t("keyboard.colors.dk63v2PinkSidePrinted");
    case "keyboard.colors.dk63v2BlackSidePrinted":
      return t("keyboard.colors.dk63v2BlackSidePrinted");
    case "keyboard.colors.dk63v2BlackFrontPrinted":
      return t("keyboard.colors.dk63v2BlackFrontPrinted");
    case "keyboard.colors.dk63v2BlackCarbonPattern":
      return t("keyboard.colors.dk63v2BlackCarbonPattern");
    case "keyboard.colors.dk63v2FoldingShadow":
      return t("keyboard.colors.dk63v2FoldingShadow");

    // 键盘配色 - ES98
    case "keyboard.colors.es98Blackpurple":
      return t("keyboard.colors.es98Blackpurple");
    case "keyboard.colors.es98Tengwangge":
      return t("keyboard.colors.es98Tengwangge");
    case "keyboard.colors.es98Whiteblue":
      return t("keyboard.colors.es98Whiteblue");
    case "keyboard.colors.es98Whitepink":
      return t("keyboard.colors.es98Whitepink");

    // 键盘配色 - X75Pro
    case "keyboard.colors.x75proWhite":
      return t("keyboard.colors.x75proWhite");
    case "keyboard.colors.x75proBlackpink":
      return t("keyboard.colors.x75proBlackpink");
    case "keyboard.colors.x75proGrapePurple":
      return t("keyboard.colors.x75proGrapePurple");
    case "keyboard.colors.x75proJiangGuoHong":
      return t("keyboard.colors.x75proJiangGuoHong");
    case "keyboard.colors.x75proMoYingJianBianDengGaoXian3":
      return t("keyboard.colors.x75proMoYingJianBianDengGaoXian3");
    case "keyboard.colors.x75proPinkGradient":
      return t("keyboard.colors.x75proPinkGradient");
    case "keyboard.colors.x75proWhiteDengGaoXian3":
      return t("keyboard.colors.x75proWhiteDengGaoXian3");
    case "keyboard.colors.x75proRussiablack":
      return t("keyboard.colors.x75proRussiablack");

    // 键盘配色 - X75Pro屏幕版
    case "keyboard.colors.x75v2proWhite":
      return t("keyboard.colors.x75proWhite");
    case "keyboard.colors.x75v2proBlackpink":
      return t("keyboard.colors.x75proBlackpink");
    case "keyboard.colors.x75v2proGrapePurple":
      return t("keyboard.colors.x75proGrapePurple");
    case "keyboard.colors.x75v2proJiangGuoHong":
      return t("keyboard.colors.x75proJiangGuoHong");
    case "keyboard.colors.x75v2proMoYingJianBianDengGaoXian3":
      return t("keyboard.colors.x75proMoYingJianBianDengGaoXian3");
    case "keyboard.colors.x75v2proPinkGradient":
      return t("keyboard.colors.x75proPinkGradient");
    case "keyboard.colors.x75v2proWhiteDengGaoXian3":
      return t("keyboard.colors.x75proWhiteDengGaoXian3");

    // 键盘配色 - X75V2
    case "keyboard.colors.x75v2Whiteblue":
      return t("keyboard.colors.x75v2Whiteblue");
    case "keyboard.colors.x75v2Blackyellow":
      return t("keyboard.colors.x75v2Blackyellow");
    case "keyboard.colors.x75v2Zheying":
      return t("keyboard.colors.x75v2Zheying");
    case "keyboard.colors.x75v2Russianwhiteblue":
      return t("keyboard.colors.x75v2Russianwhiteblue");
    case "keyboard.colors.x75v2Russianweichen":
      return t("keyboard.colors.x75v2Russianweichen");

    // 键盘配色 - X75GC
    case "keyboard.colors.x75gcSilver":
      return t("keyboard.colors.x75gcSilver");

    // 键盘配色 - ES68
    case "keyboard.colors.es68Black":
      return t("keyboard.colors.es68Black");
    case "keyboard.colors.es68White":
      return t("keyboard.colors.es68White");
    case "keyboard.colors.es68Pink":
      return t("keyboard.colors.es68Pink");
    case "keyboard.colors.es68Luotianyi":
      return t("keyboard.colors.es68Luotianyi");
    case "keyboard.colors.es68liteBlack":
      return t("keyboard.colors.es68liteBlack");
    case "keyboard.colors.es68liteSilver":
      return t("keyboard.colors.es68liteSilver");

    // 键盘配色 - M98
    case "keyboard.colors.m98FenDiYe":
      return t("keyboard.colors.m98FenDiYe");
    case "keyboard.colors.m98LeiTaoCiJianMao":
      return t("keyboard.colors.m98LeiTaoCiJianMao");

    // 键盘配色 - x87v2
    case "keyboard.colors.v80Default":
      return t("keyboard.colors.v80Default");
    case "keyboard.colors.v102Default":
      return t("keyboard.colors.v102Default");
    case "keyboard.colors.x87v2Blackberry":
      return t("keyboard.colors.x87v2Blackberry");
    case "keyboard.colors.x87v2Cherryblossompink":
      return t("keyboard.colors.x87v2Cherryblossompink");
    case "keyboard.colors.x87v2Contourline":
      return t("keyboard.colors.x87v2Contourline");
    case "keyboard.colors.x87v2Dust":
      return t("keyboard.colors.x87v2Dust");
    case "keyboard.colors.x87v2Shadowfold":
      return t("keyboard.colors.x87v2Shadowfold");

    // 键盘配色 - X87S
    case "keyboard.colors.x87sBlackpink":
      return t("keyboard.colors.x87sBlackpink");
    case "keyboard.colors.x87sLuotianyi":
      return t("keyboard.colors.x87sLuotianyi");
    case "keyboard.colors.x87sSakurapink":
      return t("keyboard.colors.x87sSakurapink");
    case "keyboard.colors.x87sWeichen":
      return t("keyboard.colors.x87sWeichen");
    case "keyboard.colors.x87sWhitedenggaoxian":
      return t("keyboard.colors.x87sWhitedenggaoxian");
    case "keyboard.colors.x87sZheying":
      return t("keyboard.colors.x87sZheying");

    // 键盘配色 - X75 V3 / Gamma75
    case "keyboard.colors.x75v3Black":
      return t("keyboard.colors.x75v3Black");
    case "keyboard.colors.x75v3Silver":
      return t("keyboard.colors.x75v3Silver");
    case "keyboard.colors.x75ultraBlack":
      return t("keyboard.colors.x75ultraBlack");
    case "keyboard.colors.x75ultraSilverRed":
      return t("keyboard.colors.x75ultraSilverRed");
    case "keyboard.colors.exxGamma75Pink":
      return t("keyboard.colors.exxGamma75Pink");
    case "keyboard.colors.exxGamma75Silver":
      return t("keyboard.colors.exxGamma75Silver");
    case "keyboard.colors.exxGamma75Black":
      return t("keyboard.colors.exxGamma75Black");
    case "keyboard.colors.exxGamma75SilverRed":
      return t("keyboard.colors.exxGamma75SilverRed");
    case "keyboard.colors.exxGamma75FeatherRed":
      return t("keyboard.colors.exxGamma75FeatherRed");
    case "keyboard.colors.exxGamma75FeatherGreen":
      return t("keyboard.colors.exxGamma75FeatherGreen");
    case "keyboard.colors.exxGamma75FeatherPurple":
      return t("keyboard.colors.exxGamma75FeatherPurple");
    case "keyboard.colors.exxGamma75FeatherBlack":
      return t("keyboard.colors.exxGamma75FeatherBlack");
    case "keyboard.colors.exxGamma75proBlack":
      return t("keyboard.colors.exxGamma75proBlack");
    case "keyboard.colors.exxGamma75proGreen":
      return t("keyboard.colors.exxGamma75proGreen");
    case "keyboard.colors.exxGamma75proPurple":
      return t("keyboard.colors.exxGamma75proPurple");
    case "keyboard.colors.exxGamma75proRed":
      return t("keyboard.colors.exxGamma75proRed");
    case "keyboard.colors.exxGamma75proSilverTwoTone":
      return t("keyboard.colors.exxGamma75proSilverTwoTone");
    case "keyboard.colors.exxGamma75proSilvery":
      return t("keyboard.colors.exxGamma75proSilvery");
    case "keyboard.colors.exxGamma75proEvoKnifeBlackFog":
      return t("keyboard.colors.exxGamma75proEvoKnifeBlackFog");
    case "keyboard.colors.exxGamma75proEvoKnifeBlackThreePiece":
      return t("keyboard.colors.exxGamma75proEvoKnifeBlackThreePiece");
    case "keyboard.colors.exxGamma75proEvoKnifeGreen":
      return t("keyboard.colors.exxGamma75proEvoKnifeGreen");
    case "keyboard.colors.exxGamma75proEvoKnifeSilverSide":
      return t("keyboard.colors.exxGamma75proEvoKnifeSilverSide");
    case "keyboard.colors.exxGamma75proEvoKnifeSilverTwoTone":
      return t("keyboard.colors.exxGamma75proEvoKnifeSilverTwoTone");
    case "keyboard.colors.exxGamma75ultraSilvery":
      return t("keyboard.colors.exxGamma75ultraSilvery");

    // 键盘配色 - ES68 EVO
    case "keyboard.colors.es68evoPink":
      return t("keyboard.colors.es68evoPink");
    case "keyboard.colors.es68evoBlack":
      return t("keyboard.colors.es68evoBlack");
    case "keyboard.colors.es68evoSilver":
      return t("keyboard.colors.es68evoSilver");
    // 键盘配色 - m80 1k
    case "keyboard.colors.m80_1k_blue":
      return t("keyboard.colors.m80_1k_blue");
    case "keyboard.colors.m80_1k_white":
      return t("keyboard.colors.m80_1k_white");
    case "keyboard.colors.m71_lipstickDot":
      return t("keyboard.colors.m71_lipstickDot");
    case "keyboard.colors.m71_cuteBearLiquidFoundation":
      return t("keyboard.colors.m71_cuteBearLiquidFoundation");
    case "keyboard.colors.m71_lipstickCuteLittleBear":
      return t("keyboard.colors.m71_lipstickCuteLittleBear");
    case "keyboard.colors.m71_liquidFoundationDots":
      return t("keyboard.colors.m71_liquidFoundationDots");
    // 键盘配色 - T87
    case "keyboard.colors.t87JiGuangWhite":
      return t("keyboard.colors.t87JiGuangWhite");
    case "keyboard.colors.t87MoYunHui":
      return t("keyboard.colors.t87MoYunHui");
    case "keyboard.colors.t87NingYePink":
      return t("keyboard.colors.t87NingYePink");
    case "keyboard.colors.t87TaoYueWhite":
      return t("keyboard.colors.t87TaoYueWhite");
    case "keyboard.colors.t87YunTianBlue":
      return t("keyboard.colors.t87YunTianBlue");
    // M98屏幕版
    case "keyboard.colors.m98TFTJingTou":
      return t("keyboard.colors.m98TFTJingTou");

    // M75
    case "keyboard.colors.m75Pink":
      return t("keyboard.colors.m75Pink");
    case "keyboard.colors.m75Green":
      return t("keyboard.colors.m75Green");
    case "keyboard.colors.m75Purple":
      return t("keyboard.colors.m75Purple");
    case "keyboard.colors.m75Cat":
      return t("keyboard.colors.m75Cat");

    // DK75
    case "keyboard.colors.dk75MistyWhite":
      return t("keyboard.colors.dk75MistyWhite");
    case "keyboard.colors.dk75MistyPurple":
      return t("keyboard.colors.dk75MistyPurple");
    case "keyboard.colors.dk75MistyPink":
      return t("keyboard.colors.dk75MistyPink");

    // DK75 E
    case "keyboard.colors.dk75EWhite":
      return t("keyboard.colors.dk75EWhite");

    // DK75 Pro
    case "keyboard.colors.dk75ProMistyWhite":
      return t("keyboard.colors.dk75ProMistyWhite");
    case "keyboard.colors.dk75ProMistyPurple":
      return t("keyboard.colors.dk75ProMistyPurple");
    case "keyboard.colors.dk75ProLakeGreen":
      return t("keyboard.colors.dk75ProLakeGreen");

    // DK87
    case "keyboard.colors.dk87BaiFenJianBian":
      return t("keyboard.colors.dk87BaiFenJianBian");
    case "keyboard.colors.dk87Black":
      return t("keyboard.colors.dk87Black");
    case "keyboard.colors.dk87BlackPink":
      return t("keyboard.colors.dk87BlackPink");
    case "keyboard.colors.dk87QingTi":
      return t("keyboard.colors.dk87QingTi");
    case "keyboard.colors.dk87Weichen":
      return t("keyboard.colors.dk87Weichen");
    case "keyboard.colors.dk87White":
      return t("keyboard.colors.dk87White");

    // DK108
    case "keyboard.colors.dk108White":
      return t("keyboard.colors.dk108White");
    case "keyboard.colors.dk108Black":
      return t("keyboard.colors.dk108Black");
    case "keyboard.colors.dk108BingDaoBlue":
      return t("keyboard.colors.dk108BingDaoBlue");
    case "keyboard.colors.dk108BlackPink":
      return t("keyboard.colors.dk108BlackPink");
    case "keyboard.colors.dk108QingTiGreen":
      return t("keyboard.colors.dk108QingTiGreen");
    case "keyboard.colors.dk108TaoYaoPink":
      return t("keyboard.colors.dk108TaoYaoPink");
    case "keyboard.colors.dk108TianKongBlue":
      return t("keyboard.colors.dk108TianKongBlue");
    case "keyboard.colors.dk108TianShuiBi":
      return t("keyboard.colors.dk108TianShuiBi");
    case "keyboard.colors.dk108WeiChen":
      return t("keyboard.colors.dk108WeiChen");
    case "keyboard.colors.dk108XiangYuPurple":
      return t("keyboard.colors.dk108XiangYuPurple");
    case "keyboard.colors.dk108YingHuaPink":
      return t("keyboard.colors.dk108YingHuaPink");

    // X87 Neon
    case "keyboard.colors.x87neonMistyBlue":
      return t("keyboard.colors.x87neonMistyBlue");

    // 耳机配色
    case "earphone.colors.hg50White":
      return t("earphone.colors.hg50White");
    case "earphone.colors.vx07LuotianyiBlue":
      return t("earphone.colors.vx07LuotianyiBlue");
    case "earphone.colors.vx07White":
      return t("earphone.colors.vx07LuotianyiBlue");
    case "earphone.colors.vx01White":
      return t("earphone.colors.vx01White");
    case "earphone.colors.vx01Black":
      return t("earphone.colors.vx01Black");
    case "earphone.colors.vx01BerryRed":
      return t("earphone.colors.vx01BerryRed");
    case "earphone.colors.vx01sBlack":
      return t("earphone.colors.vx01sBlack");
    case "earphone.colors.vx01sWhitePink":
      return t("earphone.colors.vx01sWhitePink");
    case "earphone.colors.vx01sBlackOrange":
      return t("earphone.colors.vx01sBlackOrange");
    case "earphone.colors.vx01sWhite":
      return t("earphone.colors.vx01sBlack");
    case "earphone.colors.vx02BlackRed":
      return t("earphone.colors.vx02BlackRed");
    case "earphone.colors.vx02WhiteBlue":
      return t("earphone.colors.vx02WhiteBlue");
    case "earphone.colors.vx20Default":
      return t("earphone.colors.vx20Default");
    case "earphone.colors.vx20Pink":
      return t("earphone.colors.vx20Pink");
    case "earphone.colors.vx20Blue":
      return t("earphone.colors.vx20Blue");

    default:
      return shortKey;
  }
}
